import Vue from 'vue'

// Lib imports
import axios from 'axios'

console.info('WorkTools API EndPoint : ', process.env.VUE_APP_WORKTOOLS_BASE_API)
axios.defaults.baseURL = process.env.VUE_APP_WORKTOOLS_BASE_API

Vue.prototype.$http = axios
